const TOKEN_KEY = 'admin_token'

export function getToken(): string | null {
  const stored = localStorage.getItem(TOKEN_KEY)
  if (stored) return stored

  const legacy = sessionStorage.getItem(TOKEN_KEY)
  if (legacy) {
    localStorage.setItem(TOKEN_KEY, legacy)
    sessionStorage.removeItem(TOKEN_KEY)
  }

  return legacy
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
  sessionStorage.removeItem(TOKEN_KEY)
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
}

export function isAuthenticated(): boolean {
  return !!getToken()
}
